/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchBusinessDetails } from "../../../services/BusinessService";
import formatError from "../../../services/FormatError";
import { getStatusBadge } from "../Business";
import GivenStar from "../../components/UIComponents/GivenStar";
import { createReport } from "../../../services/ReportService";
import swal from "sweetalert";
import Loader from "../../components/Loader";
import { createRate } from "../../../services/RatesService";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch } from "react-redux";
import { chatAction } from "../../../store/actions/ChatActions";
import { msgAction, roomAction } from "../../../store/actions/MsgAction";
import { createChatRoom } from "../../../services/ChatService";
import BusinessDetailsInfo from "../BusinessDetailsInfo";
import DealProgressBar from "../../components/dealProgress/DealBar";
import { fetchDealProgress } from "../../../services/DealProgressTrackerService";
import ImageLoader from "../../components/UIComponents/ImageLoader";
import { Modal } from "react-bootstrap";
import DocumentViewer from "../../components/UIComponents/DocumentViewer";
import config from "../../../config";

const AssignBusinessDetails = () => {
  const { t } = useTranslation();
  const ctxObj = JSON.parse(sessionStorage.getItem("userDetails"))?.result;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [businessDetails, setBusinessDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [rating, setRating] = useState("");
  const [comment, setComment] = useState("");
  const [reportClassification, setReportClassification] = useState("");
  const [reportDescription, setReportDescription] = useState("");
  const [progress, setProgress] = useState([]);

  //file and note----
  const [allFiles, setAllFiles] = useState([]);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState("");
  const [showDocModal, setShowDocModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState("");
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [noteContent, setNoteContent] = useState("");
  const [noteTitle, setNoteTitle] = useState("");

  useEffect(() => {
    getBusinessDetails();
    fetchDealProgress(params?.businessId).then((res) => {
      setProgress(res.data?.result);
    });
  }, []);

  const getBusinessDetails = () => {
    fetchBusinessDetails(params?.businessId)
      .then((res) => {
        setBusinessDetails(res.data?.result ?? {});
        const data = res.data?.result;
        let tempAllFiles = [];
        if (data?.documents !== null) {
          data?.documents?.map((item) => {
            tempAllFiles.push({
              type: "document",
              url: `${config?.appUrl}file/view?key=${item?.key}&type=DOCUMENT`,
            });
            return {};
          });
        }
        if (data?.images !== null) {
          data?.images?.map((item) => {
            tempAllFiles.push({
              type: "image",
              url: `${config?.appUrl}file/view?key=${item?.key}&type=IMAGE`,
            });
            return {};
          });
        }
        if (data?.videos !== null) {
          data?.videos?.map((item) => {
            tempAllFiles.push({
              type: "video",
              url: `${config?.appUrl}file/view?key=${item?.key}&type=VIDEO`,
            });
            return {};
          });
        }
        setAllFiles(tempAllFiles);
        setLoading(false);
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
        setLoading(false);
      });
  };

  const GivenReviewHandler = () => {
    setLoading(true);
    try {
      const data = {
        businessid: Number(params?.businessId),
        comment,
        rating,
      };
      createRate(data)
        .then((res) => {
          swal("Success", t("hreviewsubmit"), "success");
          setLoading(false);
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const reportOnchangeHandler = (e) => {
    setReportClassification(e.target.value);
  };

  const ReportSubmitHandler = () => {
    setLoading(true);
    const data = {
      businessid: params?.businessId,
      desclaimeraccepted: true,
      desclaimeridentifier: " ",
      description: reportDescription,
      reportclassification: reportClassification,
    };
    createReport(params?.businessId, data)
      .then((res) => {
        swal("Success", t("hreportsubmit"), "success");
        setLoading(false);
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
        setLoading(false);
      });
  };

  const onBack = () => {
    navigate("/assignbusiness");
  };

  const createRoomHandler = () => {
    setLoading(true);
    try {
      createChatRoom(params?.businessId)
        .then((res) => {
          setLoading(false);
          dispatch(roomAction(res.data?.result?.id));
          dispatch(chatAction(true));
          setTimeout(() => {
            dispatch(msgAction(true));
          }, 600);
        })
        .catch((err) => {
          formatError(err.response.data?.error);
          setLoading(false);
        });
      // dispatch(chatAction(true));
      // setTimeout(() => {
      // 	dispatch(msgAction(true));
      // }, 600);
    } catch (error) {
      setLoading(false);
      swal("Oops", t("herror"), "error");
    }
  };

  // console.log(businessDetails);
  return (
    <>
      {loading && <Loader forProcess={true} />}
      {Object.keys(businessDetails)?.length > 0 ? (
        <div className="col-lg-12">
          <div className="card project-card">
            <div className="card-header d-sm-flex align-items-center d-block">
              <div className="d-flex me-auto mb-sm-0">
                <span
                  style={{ fontSize: "18px", cursor: "pointer" }}
                  className="d-flex justify-content-start align-items-center me-3"
                  onClick={onBack}
                >
                  <i className="fa fa-arrow-left"></i>
                </span>
                <h4 className="card-title">{t("assignedBusiness")}</h4>
              </div>

              <Icon
                icon="token:chat"
                fontSize={40}
                style={{ cursor: "pointer" }}
                onClick={createRoomHandler}
                className="me-4"
              />
              <a href={`mailto:${businessDetails?.contact_email}`}>
                <Icon
                  icon="ic:outline-email"
                  fontSize={40}
                  style={{ cursor: "pointer" }}
                  className="me-4"
                />
              </a>
              {/* <Link to={`/calendar/${params?.businessId}`}>
                <Icon
                  icon="mdi:calendar"
                  fontSize={40}
                  style={{ cursor: "pointer" }}
                />
              </Link> */}
              {/* <a
                href={`https://calendly.com/app/scheduling/meeting_types/user/me`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  icon="mdi:calendar"
                  fontSize={40}
                  style={{ cursor: "pointer" }}
                />
              </a> */}
            </div>

            <div className="card-body">
              <div className="business-header d-flex justify-content-between">
                <div className="d-flex align-items-start">
                  <div className="me-3">
                    {businessDetails?.icon ? (
                      <img
                        src={`${config?.appUrl}file/view?key=${businessDetails?.icon}&type=IMAGE`}
                        className="business-logo"
                        alt="Business Logo"
                      />
                    ) : (
                      <div className="logo-placeholder">Logo</div>
                    )}
                  </div>
                  <div className="flex-grow-1">
                    <h1 className="business-title">{businessDetails?.name}</h1>
                    {businessDetails?.website !== "" && (
                      <div className="business-subtitle">
                        🌐 {businessDetails?.website}
                      </div>
                    )}
                    <div className="business-subtitle">
                      🏢 {businessDetails?.domain} • {businessDetails?.type}
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-start">
                  <span
                    className={`badge d-sm-inline-block d-none ${getStatusBadge(
                      businessDetails?.status
                    )}`}
                  >
                    {businessDetails?.status}
                  </span>
                </div>
              </div>
              {businessDetails?.status !== "Unpublished" && (
                <DealProgressBar stages={progress} />
              )}
              <BusinessDetailsInfo businessDetails={businessDetails} />

              {allFiles?.filter((f) => f.type === "image")?.length !== 0 && (
                <div>
                  <div
                    className="d-flex my-2 p-2  border-bx"
                    style={{
                      overflowX:
                        allFiles?.filter((f) => f.type === "image")?.length > 6
                          ? "scroll"
                          : "hidden",
                    }}
                  >
                    {allFiles
                      ?.filter((f) => f.type === "image")
                      ?.map((item) => {
                        return (
                          <div
                            style={{
                              width: "200px",
                              height: "150px",
                              marginRight: "10px",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedImage(item?.url);
                              setShowImageModal(true);
                            }}
                          >
                            <ImageLoader
                              src={item?.url}
                              alt="image"
                              width="200px"
                              height="150px"
                            />
                          </div>
                          // <img
                          // 	src={item?.url}
                          // 	alt=""
                          // 	loading="lazy"
                          // 	style={{
                          // 		width: "200px",
                          // 		height: "150px",
                          // 		marginRight: "10px",
                          // 		borderRadius: "5px",
                          // 		cursor: "pointer",
                          // 	}}
                          // onClick={() => {
                          // 	setSelectedImage(item?.url);
                          // 	setShowImageModal(true);
                          // }}
                          // />
                        );
                      })}
                  </div>
                </div>
              )}

              {allFiles?.filter((f) => f.type === "video")?.length !== 0 && (
                <div className="my-4">
                  <h4>{t("videos")}</h4>
                  <div
                    className="d-flex my-2 p-2  border-bx"
                    style={{
                      overflowX:
                        allFiles?.filter((f) => f.type === "video")?.length > 6
                          ? "scroll"
                          : "hidden",
                    }}
                  >
                    {allFiles
                      ?.filter((f) => f.type === "video")
                      ?.map((item) => {
                        return (
                          <video
                            src={item?.url}
                            alt=""
                            // loading="lazy"
                            style={{
                              width: "200px",
                              height: "150px",
                              marginRight: "10px",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            controls
                            onClick={() => {
                              setSelectedVideo(item?.url);
                              setShowVideoModal(true);
                            }}
                          />
                        );
                      })}
                  </div>
                </div>
              )}

              {allFiles?.filter((f) => f.type === "document")?.length !== 0 && (
                <div className="my-4">
                  <h4>{t("hsubmitdocument")}</h4>
                  <div
                    className="row my-2 p-2  border-bx"
                    style={{
                      overflowX:
                        allFiles?.filter((f) => f.type === "document")?.length >
                        6
                          ? "scroll"
                          : "hidden",
                    }}
                  >
                    {allFiles
                      ?.filter((f) => f.type === "document")
                      ?.map((item) => {
                        return (
                          <div className="col-4 ">
                            <div
                              className=" d-flex align-items-center"
                              style={{
                                display: "inline-flex",
                                width: "fit-content",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setSelectedDoc(item?.url);
                                setShowDocModal(true);
                              }}
                            >
                              <Icon
                                icon="vscode-icons:file-type-pdf2"
                                style={{
                                  fontSize: "50px",
                                  marginRight: "10px",
                                }}
                              />
                              <p className="mt-1" style={{ margin: 0 }}>
                                Document 1
                              </p>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}

              {showImageModal && (
                <Modal
                  className="modal fade "
                  // dialogClassName="modal-50w"
                  size="lg"
                  backdrop="static"
                  show={showImageModal}
                  onHide={() => {
                    setSelectedImage("");
                    setShowImageModal(false);
                  }}
                >
                  <div className="modal-header border-0">
                    <button
                      type="button"
                      className="close btn"
                      onClick={() => {
                        setSelectedImage("");
                        setShowImageModal(false);
                      }}
                    >
                      <span>×</span>
                    </button>
                  </div>
                  <div className="mx-auto my-5">
                    <img
                      src={selectedImage}
                      alt=""
                      // loading={(e) => console.log(e)}
                      style={{
                        width: "600px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </Modal>
              )}
              {showVideoModal && (
                <Modal
                  className="modal fade "
                  // dialogClassName="modal-50w"
                  size="lg"
                  backdrop="static"
                  show={showVideoModal}
                  onHide={() => {
                    setSelectedVideo("");
                    setShowVideoModal(false);
                  }}
                >
                  <div className="modal-header border-0">
                    <button
                      type="button"
                      className="close btn"
                      onClick={() => {
                        setSelectedVideo("");
                        setShowVideoModal(false);
                      }}
                    >
                      <span>×</span>
                    </button>
                  </div>
                  <div className="mx-auto my-5">
                    <video
                      src={selectedVideo}
                      alt=""
                      // loading="lazy"
                      style={{
                        width: "500px",
                        cursor: "pointer",
                      }}
                      controls
                    />
                  </div>
                </Modal>
              )}
              {showDocModal && (
                <DocumentViewer
                  filePath={selectedDoc}
                  open={showDocModal}
                  handleClose={() => {
                    setSelectedDoc("");
                    setShowDocModal(false);
                  }}
                />
              )}

              {/* <div className="py-3 mt-3 text-center d-flex">
							<Button
								size="lg"
								onClick={() => {
									setShowReviewModal(true);
								}}
								variant="outline-primary"
								className="d-flex align-items-center justify-content-center mx-auto"
							>
								<Icon icon="mdi:edit" fontSize={20} />
								<span className="ms-2">Write Review</span>
							</Button>
							<Button
								size="lg"
								onClick={() => {
									setBusinessId(businessDetails.id);
									setShowReportModal(true);
								}}
								variant="outline-primary"
								className="d-flex align-items-center justify-content-center mx-auto"
							>
								<Icon icon="mdi:edit" fontSize={20} />
								<span className="ms-2">Report</span>
							</Button>
						</div> */}
              {businessDetails?.rating === -1 && ctxObj?.role.id === 4 && (
                <div className="w-100 d-flex mt-5">
                  {/* review section */}
                  <div className="w-50 border-end card">
                    <div className="">
                      <div className="modal-header">
                        <h4 className="modal-title fs-20">{t("hwrite")}</h4>
                      </div>

                      <div className="w-75 mx-auto my-5">
                        <p className="d-flex align items-center">
                          <span className="me-3">{t("hreviewabout")}</span>{" "}
                          <GivenStar value={rating} setValue={setRating} />
                        </p>
                        <textarea
                          onChange={(e) => setComment(e.target.value)}
                          className="border-1 rounded outline-0 p-4 w-100"
                          rows="5"
                          //   cols="40"
                          placeholder="Review"
                        ></textarea>
                      </div>

                      <div className="d-flex justify-content-end mb-2 me-5">
                        <button
                          type="submit"
                          className="btn btn-primary "
                          onClick={GivenReviewHandler}
                          disabled={rating === ""}
                        >
                          {t("hpostreview")}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* report section */}
                  <div className="w-50 card">
                    <div className="">
                      <div className="modal-header">
                        <h4 className="modal-title fs-20">
                          {t("hreportbusiness")}
                        </h4>
                      </div>

                      <div className="mx-5 my-5">
                        <div class="mb-3">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label me-3"
                          >
                            {t("hselectReport")}
                          </label>
                          <select
                            id="exampleFormControlInput1"
                            className="input-search form-control px-2"
                            onChange={reportOnchangeHandler}
                          >
                            <option value="value1">{t("hfakeBusiness")}</option>
                            <option value="value1">Spam</option>
                            <option value="value1">{t("hpriceGouging")}</option>
                            <option value="value1">{t("hlicencing")}</option>
                            <option value="value1">
                              {t("haccessibility")}
                            </option>
                            <option value="value1">
                              {t("hackinhSecurity")}
                            </option>
                          </select>
                        </div>

                        {reportClassification !== "" && (
                          <textarea
                            onChange={(e) =>
                              setReportDescription(e.target.value)
                            }
                            class="border-1 rounded outline-0 p-4 mt-5"
                            rows="5"
                            //   cols="90"
                            className="w-100 p-3 rounded-2"
                            placeholder="provide report details"
                          ></textarea>
                        )}
                      </div>

                      <div className="d-flex justify-content-end mb-4 me-5">
                        <button
                          type="submit"
                          disabled={
                            reportClassification === "" ||
                            reportDescription === ""
                          }
                          className="btn btn-primary "
                          onClick={ReportSubmitHandler}
                        >
                          {t("hreport")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AssignBusinessDetails;
